import { render } from "./Shopdetail.vue?vue&type=template&id=4c98c53c&scoped=true"
import script from "./Shopdetail.vue?vue&type=script&lang=js"
export * from "./Shopdetail.vue?vue&type=script&lang=js"

import "./Shopdetail.vue?vue&type=style&index=0&id=4c98c53c&scoped=true&lang=css"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c98c53c"]])

export default __exports__